export default "__VITE_ASSET__QJ08oUu0__"